import React from 'react';

/**
 * Shared end-of-game dialog for both games.
 * Parents must only render it when the opponent-left / opponent-disconnected
 * overlays are NOT showing — those take priority (e.g. the opponent left
 * while we were deciding on a rematch).
 */
export default function GameOverDialog({ result, rematchMine, rematchOpponent, onRestart, onLeave }) {
  let title, message;
  if (result === 'win') {
    title = '🎉 You win!';
    message = 'Congrats!!!';
  } else if (result === 'draw') {
    title = '🤝 Draw!';
    message = 'Well matched — nobody wins this one.';
  } else {
    title = '😞 Uh-oh…';
    message = 'Good luck next time.';
  }

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h3>{title}</h3>
        <p>{message}</p>

        {rematchMine ? (
          <>
            <p><em>Waiting for your opponent to accept the rematch…</em></p>
            <div className="spinner" style={{ margin: '10px auto' }} />
            <div className="modal-actions">
              <button className="btn btn-danger" onClick={onLeave}>Leave to Lobby</button>
            </div>
          </>
        ) : (
          <>
            {rematchOpponent && (
              <p><strong>⚔️ Your opponent wants a rematch!</strong></p>
            )}
            <div className="modal-actions">
              <button className="btn btn-primary" onClick={onRestart}>🔄 Restart</button>
              <button className="btn btn-danger" onClick={onLeave}>Leave to Lobby</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
